import React from "react";
import { RedirectIcon } from "../../Assets/Icons";

const ApplicationCard = ({
  showResources = false,
  showRedirectIcon = false,
  showOpenBtn = true,
  assignedResources = "",
  name = "",
  description = "",
  logo = "",
  onClick = () => { },
  resourceClick = () => { },
  checkbox = null,
  showCheckbox = false,
  beta = false,
  checked = false,
}) => {
  const handleAppClick = () => {
    if (onClick) {
      onClick();
    }
  };

  const handleResourceClick = (event) => {
    if (resourceClick) {
      resourceClick();
    }
  };

  return (
    <>
      <div className="position-relative">
        {showCheckbox &&
          <div className="rightcardcheckbox">
            {checkbox}
          </div>
        }
        <div
          className={`app-card ${showResources ? "with-resource" : ""} ${checked ? "checked" : ""} `}
          onClick={handleAppClick}
        >
          <div className="logo-redirect">
            <img src={logo} />
            <div className="extrass">
              {beta && <span className="beta">Beta</span>}
              {showRedirectIcon && (
                <span className="redirect">
                  <RedirectIcon />
                </span>
              )}
            </div>
          </div>
          <h6 className="title">{name}</h6>
          <p> {description} </p>
          {showResources && <div className="stats">
            {showOpenBtn && (
              <button className="default-action" onClick={handleResourceClick}>
                Open
              </button>
            )}

            {assignedResources > 0 && (
              <div className="resource">
                <h6>{assignedResources}</h6>
                <p> Assig. Resource </p>
              </div>
            )}
          </div>}
        </div>
      </div>
    </>
  );
};

export default ApplicationCard;
